export default __webpack_public_path__ + "static/media/500.53f218d1.svg";